import { EntityModel } from '@/interfaces'
import {
  ALL_PARTNERS_QUERY,
  CREATE_PARTNER_MUTATION,
  DELETE_PARTNER_MUTATION,
  FORCE_DELETE_PARTNER_MUTATION,
  SINGLE_PARTNER_QUERY,
  UPDATE_PARTNER_MUTATION,
} from './graphql'
import mediaFileEntity from '@/entities/mediaFile/entity'

const travelPartnerModel: EntityModel = {
  name: 'partner',
  namePlural: 'partners',
  uniqueName: 'travelPartner',
  uniqueNamePlural: 'travelPartners',
  path: 'travel/partner',
  baseUrl: '/travel/partners',
  translationPrefix: 'entities:travelPartner.',
  getDisplayName: (values: any) => {
    return values.name
  },
  gql: {
    getAll: ALL_PARTNERS_QUERY,
    getSingle: SINGLE_PARTNER_QUERY,
    create: CREATE_PARTNER_MUTATION,
    update: UPDATE_PARTNER_MUTATION,
    delete: DELETE_PARTNER_MUTATION,
    forceDelete: FORCE_DELETE_PARTNER_MUTATION,
  },
  attributes: {
    name: {
      name: 'name',
      label: 'entities:travelPartner.attributes.name.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'required',
        },
      ],
    },
    url: {
      name: 'url',
      label: 'entities:travelPartner.attributes.url.label',
      type: 'value',
      dataType: 'string',
      defaultInput: true,
      inputType: 'text',
      validationType: 'string',
      validations: [
        {
          type: 'regex',
          pattern: /https?:\/\/(www.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&\/\/=]*)/,
        },
      ],
    },
    logo: {
      name: 'logo',
      label: 'entities:travelPartner.attributes.logo.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
    logoWidth: {
      name: 'logoWidth',
      label: 'entities:travelPartner.attributes.logoWidth.label',
      type: 'value',
      dataType: 'number',
      defaultInput: true,
      inputType: 'number',
      validationType: 'string',
      validations: [],
    },
    gtcPdf: {
      name: 'gtcPdf',
      label: 'entities:travelPartner.attributes.gtcPdf.label',
      type: 'entityObject',
      dataType: 'any',
      getEntity: () => {
        return mediaFileEntity
      },
      defaultInput: false,
      inputType: 'select',
      validationType: 'string',
      validations: [],
    },
  },
}

export default travelPartnerModel
